module.exports = __webpack_public_path__ + "static/media/cambodia-round.6c583666.svg";